import { render, staticRenderFns } from "./UtilButton.vue?vue&type=template&id=5e1e5755"
import script from "./UtilButton.vue?vue&type=script&lang=js"
export * from "./UtilButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports